// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"4c9e4d94","385":"0eca1bb0"}[chunkId] + ".chunk.css";
};